import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { FC } from 'react';

interface IConfirmValidationModalProps {
  title: string;
  description: string;
  confirmLabel: string;
  confirmVariant?: 'text' | 'contained';
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmValidationModal: FC<IConfirmValidationModalProps> = ({
  title,
  description,
  confirmLabel,
  confirmVariant = 'text',
  onClose,
  onConfirm,
}) => (
  <Dialog maxWidth="xs" className="dark" open onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{description}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Continue Validating</Button>
      <Button variant={confirmVariant} color="primary" onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export { ConfirmValidationModal };